import type { RouteRecordRaw } from 'vue-router';

import publicRoutes from './public';
import { routes as procurementRoutes } from '@precon-tools-suite-by-shared/gino-procurements-feature';
import { routes as importRoutes } from '@precon-tools-suite-by-shared/gino-user-imports-feature';
import { routes as riskDatabaseRoutes } from '@precon-tools-suite-by-shared/gino-risk-database-feature';
import { routes as riskConfigRoutes } from '@precon-tools-suite-by-shared/gino-risk-configurations-feature';
import { createRoutes as createVerificationRoutes } from '@precon-tools-suite-by-shared/gino-verification-configurations-feature';
import { routes as reportRoutes } from '@precon-tools-suite-by-shared/gino-analysis-reports-feature';

export default [
    ...publicRoutes,
    ...procurementRoutes,
    ...importRoutes,
    ...riskDatabaseRoutes,
    ...riskConfigRoutes,
    ...createVerificationRoutes('/verification-configurations'),
    ...reportRoutes,
] as RouteRecordRaw[];
